import type { Duration } from 'types/units';
import { ZERO_COST } from './currency';

export const EMPTY_COST = ZERO_COST;

export const EMPTY_DURATION: Duration = {
  hours: 0,
  minutes: 0,
  seconds: 0,
  formatted: '00:00',
  total_hours: 0.0,
  total_seconds: 0,
  total_minutes: 0,
};

export const ReportBatchValidationMessage = {
  CannotUpdateLocked: 'You may not make changes to locked entries.',
  CannotUpdateLockedDay: 'You may not make changes to entries on locked days.',
};
